import { Edit, SimpleForm, TextField, TextInput } from 'react-admin';
import { CustomTitle } from '../../components/CustomTitle';

export const PathEdit = (props: unknown) => (
  <Edit {...props} title={<CustomTitle />}>
    <SimpleForm>
      <TextField source="id" />
      <TextInput source="title" />
    </SimpleForm>
  </Edit>
);
